import { render, staticRenderFns } from "./SalesInvoiceViewDetailsSalesInvoiceItemTable.vue?vue&type=template&id=5faa1ecc"
import script from "./SalesInvoiceViewDetailsSalesInvoiceItemTable.vue?vue&type=script&lang=js"
export * from "./SalesInvoiceViewDetailsSalesInvoiceItemTable.vue?vue&type=script&lang=js"
import style0 from "./SalesInvoiceViewDetailsSalesInvoiceItemTable.vue?vue&type=style&index=0&id=5faa1ecc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports